import React from "react";
import { Add as AddIcon, Remove as RemoveIcon, Delete as DeleteIcon } from "@mui/icons-material";

interface CartItem {
  productId: string | number;
  branchId: string | number;
  name: string;
  price: number;
  quantity: number;
}


interface CartStoreItemsProps {
  storeId: string | number;
  items: any[];
  expandedStores: Record<string, boolean>;
  isRTL: boolean;
  currency: (value: number) => string;
  t: (key: string) => string;
  updateQuantity: (
    productId: any,
    branchId: any,
    quantity: number
  ) => void;
  removeItem: (productId: any, branchId: any) => void;
}

const CartStoreItems: React.FC<CartStoreItemsProps> = ({
  storeId,
  items,
  expandedStores,
  isRTL,
  currency,
  t,
  updateQuantity,
  removeItem,
}) => {
  return (
    <div
      className={`space-y-3 transition-all duration-500 overflow-hidden ${
        expandedStores[storeId] ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
      }`}
    >
      {items.map((it, index) => (
        <div
          key={`${it.productId}-${it.branchId}`}
          className={`flex justify-between items-center p-3 rounded-xl 
          bg-gradient-to-r from-white to-gray-50 
          hover:from-green-50 hover:to-emerald-50 
          transition-all duration-300 border border-gray-100   flex-wrap
          hover:border-green-200 group ${isRTL ? "flex-row-reverse" : ""} animate-slideRight`}
          style={{ animationDelay: `${index * 50}ms` }}
        >
          {/* Product Info */}
          <div className={`flex-1  ${isRTL ? "text-right" : "text-left"}`}>
            <div className="font-medium text-gray-900 group-hover:text-emerald-800 transition-colors duration-200">
              {it.name}
            </div>
            <div className="text-sm text-gray-500 mt-1">
              {currency(it.price)} {t("currency.egp")} × {it.quantity}
            </div>
          </div>

          {/* Actions */}
          <div className={`flex items-center gap-3 ${isRTL ? "flex-row-reverse" : ""} justify-between w-full`}>
            {/* Quantity Controls */}
            <div className="flex items-center gap-1 bg-white rounded-full p-1 shadow-sm border border-gray-200">
              <button
                onClick={() => updateQuantity(it.productId, it.branchId, it.quantity - 1)}
                disabled={it.quantity <= 1}
                className="w-10 h-10 flex items-center justify-center rounded-full
                text-gray-600 hover:text-white
                hover:bg-gradient-to-r hover:from-red-500 hover:to-red-600
                disabled:opacity-30 disabled:cursor-not-allowed
                transition-all duration-200 shadow-sm"
              >
                <RemoveIcon />
              </button>

              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-green-50 to-emerald-50 rounded-full">
                <span className="font-bold text-gray-900 text-lg">{it.quantity}</span>
              </div>

              <button
                onClick={() => updateQuantity(it.productId, it.branchId, it.quantity + 1)}
                className="w-10 h-10 flex items-center justify-center rounded-full
                text-gray-600 hover:text-white
                hover:bg-gradient-to-r hover:from-green-500 hover:to-emerald-500
                transition-all duration-200 shadow-sm"
              >
                <AddIcon />
              </button>
            </div>

            {/* Delete */}
            <button
              onClick={() => removeItem(it.productId, it.branchId)}
              className="w-10 h-10 flex items-center justify-center rounded-full
              bg-gradient-to-r from-red-50 to-pink-50 text-red-600
              hover:text-white hover:from-red-600 hover:to-pink-600
              transition-all duration-200 shadow-sm"
            >
              <DeleteIcon />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CartStoreItems;
